// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--2fm5R","formItemCol":"formItemCol--2sj9f","labelInfo":"labelInfo--s0Mre","actionButton":"actionButton--355Je"};